import { render, staticRenderFns } from "./WSSwitch.vue?vue&type=template&id=b3ba853a&"
import script from "./WSSwitch.vue?vue&type=script&lang=js&"
export * from "./WSSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports